import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { BasePaths } from 'src/app/constants/routes';

import { SessionStatus } from 'src/app/constants/session';
import { StoreNames } from 'src/app/constants/storage-names';
import { Session } from 'src/app/models/session';
import { environment } from 'src/environments/environment';

const localPreFix = 'mwp-sst-';

@Injectable({ providedIn: 'root' })
export class SessionService {
    public session: Session = new Session();
    public $Session = new BehaviorSubject(this.session);
    public $SessionClear = new BehaviorSubject(SessionStatus.initalize);

    constructor(
        private router: Router,
    ) {
        let sessionState = this.retrieve(StoreNames.session);
        if (sessionState) {
            this.session = sessionState;
            this.$Session.next(this.session);
        }
    }

    public setStore(p_BehaviorSubject: BehaviorSubject<any>, p_ServiceObject: any, p_Object: any, p_StoreName: string) {
        p_ServiceObject = p_Object;
        this.store(p_StoreName, p_ServiceObject);
        p_BehaviorSubject.next(p_ServiceObject);
    }

    public clearMemberSession(): void {
        this.remove(StoreNames.benefitCategoriesList);
        this.session.isMember = false;
        this.session.member = null;
        this.setSession();

        this.$SessionClear.next(SessionStatus.clearMember);
    }

    public setSession(): void {
        this.store(StoreNames.session, this.session);
        this.$Session.next(this.session);
    }

    public checkOpertingVersion(version: string): void {
        this.session.isVersionIncompatible = version !== environment.appVersion;
        if (this.session.isVersionIncompatible)
            this.router.navigateByUrl(BasePaths.VersionError);
    }

    public versionSetGuard(version: string): void {
        this.checkOpertingVersion(version);
        if (this.session.isVersionIncompatible) {
            this.session.operatingMode.version = version;
            this.setSession();
        }
    }

    public logout() {
        // Do persist not Operating Mode
        const l_isFirstResponder = this.session.isFirstResponder;
        const l_firstResponderComCode = this.session.firstResponderComCode;
        const l_IsDarkMode = this.session.isDarkMode;
        const l_OperatingMode = this.session.operatingMode;
        const l_Language = this.session.language;
        sessionStorage.clear();

        this.session = new Session();
        this.session.isFirstResponder = l_isFirstResponder;
        this.session.firstResponderComCode = l_firstResponderComCode;
        this.session.isDarkMode = l_IsDarkMode;
        this.session.operatingMode = l_OperatingMode;
        this.session.language = l_Language;
        this.setSession();

        this.$SessionClear.next(SessionStatus.clearSession);
    }

    // Storage
    public store<T>(storeKey: string, object: T): void {
        sessionStorage.setItem(`${localPreFix}${storeKey}`, JSON.stringify(object));
    }

    public remove(storeKey: string): any {
        sessionStorage.removeItem(`${localPreFix}${storeKey}`);
    }

    public retrieve(storeKey: string): any {
        return JSON.parse(sessionStorage.getItem(`${localPreFix}${storeKey}`));
    }

    public clear(): void {
        sessionStorage.clear();
    }
}